let JoinUNdata=[
  {
    "id": 7,
    "iso3": "ARG",
    "iso": "AR",
    "CountryEN": "Argentina",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "الأرجنتين",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 9,
    "iso3": "AUS",
    "iso": "AU",
    "CountryEN": "Australia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Asia Pacific",
    "countryAR": "أستراليا",
    "commentAR": null,
    "RegionAR": "أستراليا"
  },
  {
    "id": 16,
    "iso3": "BLR",
    "iso": "BY",
    "CountryEN": "Belarus",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "بيلاروس",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 17,
    "iso3": "BEL",
    "iso": "BE",
    "CountryEN": "Belgium",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "بلجيكا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 21,
    "iso3": "BOL",
    "iso": "BO",
    "CountryEN": "Bolivia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "بوليفيا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 24,
    "iso3": "BRA",
    "iso": "BR",
    "CountryEN": "Brazil",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "البرازيل",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 31,
    "iso3": "CAN",
    "iso": "CA",
    "CountryEN": "Canada",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "US & Canada",
    "countryAR": "كندا",
    "commentAR": null,
    "RegionAR": "أميركا وكندا"
  },
  {
    "id": 35,
    "iso3": "CHL",
    "iso": "CL",
    "CountryEN": "Chile",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "تشيلي",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 36,
    "iso3": "CHN",
    "iso": "CN",
    "CountryEN": "China",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Asia",
    "countryAR": "الصين",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 37,
    "iso3": "COL",
    "iso": "CO",
    "CountryEN": "Colombia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "كولومبيا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 40,
    "iso3": "CRI",
    "iso": "CR",
    "CountryEN": "Costa Rica",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "كوستاريكا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 43,
    "iso3": "CUB",
    "iso": "CU",
    "CountryEN": "Cuba",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "كوبا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 46,
    "iso3": "DNK",
    "iso": "DK",
    "CountryEN": "Denmark",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "دانمارك",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 49,
    "iso3": "DOM",
    "iso": "DO",
    "CountryEN": "Dominican Republic",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "الدومينيكان",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 52,
    "iso3": "ECU",
    "iso": "EC",
    "CountryEN": "Ecuador",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "الإكوادور",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 53,
    "iso3": "EGY",
    "iso": "EG",
    "CountryEN": "Egypt",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "مصر",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 54,
    "iso3": "SLV",
    "iso": "SV",
    "CountryEN": "El Salvador",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "السلفادور",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 58,
    "iso3": "ETH",
    "iso": "ET",
    "CountryEN": "Ethiopia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Africa",
    "countryAR": "إثيوبيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 61,
    "iso3": "FRA",
    "iso": "FR",
    "CountryEN": "France",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "فرنسا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 67,
    "iso3": "GRC",
    "iso": "GR",
    "CountryEN": "Greece",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "اليونلن",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 69,
    "iso3": "GTM",
    "iso": "GT",
    "CountryEN": "Guatemala",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "غواتيمالا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 73,
    "iso3": "HTI",
    "iso": "HT",
    "CountryEN": "Haiti",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "هاييتي",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 74,
    "iso3": "HND",
    "iso": "HN",
    "CountryEN": "Honduras",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "هندوراس",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 77,
    "iso3": "IND",
    "iso": "IN",
    "CountryEN": "India",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Asia",
    "countryAR": "الهند",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 79,
    "iso3": "IRN",
    "iso": "IR",
    "CountryEN": "Iran",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "إيران",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 80,
    "iso3": "IRQ",
    "iso": "IQ",
    "CountryEN": "Iraq",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "العراق",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 94,
    "iso3": "LBN",
    "iso": "LB",
    "CountryEN": "Lebanon",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "لبنان",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 96,
    "iso3": "LBR",
    "iso": "LR",
    "CountryEN": "Liberia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Africa",
    "countryAR": "ليبيريا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 100,
    "iso3": "LUX",
    "iso": "LU",
    "CountryEN": "Luxembourg",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "لوكسمبورغ",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 110,
    "iso3": "MEX",
    "iso": "MX",
    "CountryEN": "Mexico",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "المكسيك",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 122,
    "iso3": "NLD",
    "iso": "NL",
    "CountryEN": "Netherlands",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "هولندا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 123,
    "iso3": "NZL",
    "iso": "NZ",
    "CountryEN": "New Zealand",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Asia Pacific",
    "countryAR": "نيوزيلندا",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 124,
    "iso3": "NIC",
    "iso": "NI",
    "CountryEN": "Nicaragua",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "نيكاراغوا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 129,
    "iso3": "NOR",
    "iso": "NO",
    "CountryEN": "Norway",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "النرويج",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 133,
    "iso3": "PAN",
    "iso": "PA",
    "CountryEN": "Panama",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "بنما",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 135,
    "iso3": "PRY",
    "iso": "PY",
    "CountryEN": "Paraguay",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "باراغواي",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 136,
    "iso3": "PER",
    "iso": "PE",
    "CountryEN": "Peru",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "بيرو",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 137,
    "iso3": "PHL",
    "iso": "PH",
    "CountryEN": "Philippines",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Asia",
    "countryAR": "الفلبين",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 138,
    "iso3": "POL",
    "iso": "PL",
    "CountryEN": "Poland",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "بولندا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 142,
    "iso3": "RUS",
    "iso": "RU",
    "CountryEN": "Russia (joined as Soviet Union)",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "روسيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 150,
    "iso3": "SAU",
    "iso": "SA",
    "CountryEN": "Saudi Arabia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "السعودية",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 160,
    "iso3": "ZAF",
    "iso": "ZA",
    "CountryEN": "South Africa",
    "commentEN": "Founding member. Suspended in 1974, reinstated in 1994",
    "UNJoin": 1945,
    "Region": "Africa",
    "countryAR": "جنوب أفريقيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 170,
    "iso3": "SYR",
    "iso": "SY",
    "CountryEN": "Syria",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "سوريا",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 178,
    "iso3": "TUR",
    "iso": "TR",
    "CountryEN": "Turkey",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Middle East",
    "countryAR": "تركيا",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 182,
    "iso3": "UKR",
    "iso": "UA",
    "CountryEN": "Ukraine",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "أوكرانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 184,
    "iso3": "GBR",
    "iso": "GB",
    "CountryEN": "United Kingdom",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "المملكة المتحدة",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 185,
    "iso3": "USA",
    "iso": "US",
    "CountryEN": "United States",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "US & Canada",
    "countryAR": "الولايات المتحدة الأميركية",
    "commentAR": null,
    "RegionAR": "أميركا وكندا"
  },
  {
    "id": 186,
    "iso3": "URY",
    "iso": "UY",
    "CountryEN": "Uruguay",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "الأورغواى",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 189,
    "iso3": "VEN",
    "iso": "VE",
    "CountryEN": "Venezuela",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Latin America",
    "countryAR": "فنزويلا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 194,
    "iso3": "CSK",
    "iso": "CS",
    "CountryEN": "Czechoslovakia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "تشيكيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 195,
    "iso3": "YUG",
    "iso": "YU",
    "CountryEN": "Yugoslavia",
    "commentEN": "Founding member",
    "UNJoin": 1945,
    "Region": "Europe",
    "countryAR": "يوغسلافيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 1,
    "iso3": "AFG",
    "iso": "AF",
    "CountryEN": "Afghanistan",
    "commentEN": null,
    "UNJoin": 1946,
    "Region": "Asia",
    "countryAR": "أفغانستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 76,
    "iso3": "ISL",
    "iso": "IS",
    "CountryEN": "Iceland",
    "commentEN": null,
    "UNJoin": 1946,
    "Region": "Europe",
    "countryAR": "آيسلندا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 168,
    "iso3": "SWE",
    "iso": "SE",
    "CountryEN": "Sweden",
    "commentEN": null,
    "UNJoin": 1946,
    "Region": "Europe",
    "countryAR": "السويد",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 173,
    "iso3": "THA",
    "iso": "TH",
    "CountryEN": "Thailand",
    "commentEN": null,
    "UNJoin": 1946,
    "Region": "Asia",
    "countryAR": "تايلند",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 131,
    "iso3": "PAK",
    "iso": "PK",
    "CountryEN": "Pakistan",
    "commentEN": null,
    "UNJoin": 1947,
    "Region": "Asia",
    "countryAR": "باكستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 191,
    "iso3": "YEM",
    "iso": "YE",
    "CountryEN": "Yemen",
    "commentEN": null,
    "UNJoin": 1947,
    "Region": "Middle East",
    "countryAR": "اليمن",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 118,
    "iso3": "MMR",
    "iso": "MM",
    "CountryEN": "Myanmar",
    "commentEN": null,
    "UNJoin": 1948,
    "Region": "Asia",
    "countryAR": "ميانمار (بورما)",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 82,
    "iso3": "ISR",
    "iso": "IL",
    "CountryEN": "Israel",
    "commentEN": "Created in 1948",
    "UNJoin": 1949,
    "Region": "Middle East",
    "countryAR": "إسرائيل",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 78,
    "iso3": "IDN",
    "iso": "ID",
    "CountryEN": "Indonesia",
    "commentEN": null,
    "UNJoin": 1950,
    "Region": "Asia",
    "countryAR": "إندونيسيا",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 2,
    "iso3": "ALB",
    "iso": "AL",
    "CountryEN": "Albania",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "ألبانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 10,
    "iso3": "AUT",
    "iso": "AT",
    "CountryEN": "Austria",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "النمسا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 26,
    "iso3": "BGR",
    "iso": "BG",
    "CountryEN": "Bulgaria",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "بلغاريا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 29,
    "iso3": "KHM",
    "iso": "KH",
    "CountryEN": "Cambodia",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Asia",
    "countryAR": "كمبوديا",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 60,
    "iso3": "FIN",
    "iso": "FI",
    "CountryEN": "Finland",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "فنلندا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 75,
    "iso3": "HUN",
    "iso": "HU",
    "CountryEN": "Hungary",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "مجر ( هنغاريا )",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 81,
    "iso3": "IRL",
    "iso": "IE",
    "CountryEN": "Ireland",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "أيرلندا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 83,
    "iso3": "ITA",
    "iso": "IT",
    "CountryEN": "Italy",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "إيطاليا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 86,
    "iso3": "JOR",
    "iso": "JO",
    "CountryEN": "Jordan",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Middle East",
    "countryAR": "الأردن",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 92,
    "iso3": "LAO",
    "iso": "LA",
    "CountryEN": "Laos",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Asia",
    "countryAR": "لاوس",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 97,
    "iso3": "LBY",
    "iso": "LY",
    "CountryEN": "Libya",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Middle East",
    "countryAR": "ليبيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 121,
    "iso3": "NPL",
    "iso": "NP",
    "CountryEN": "Nepal",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Asia",
    "countryAR": "نيبال",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 139,
    "iso3": "PRT",
    "iso": "PT",
    "CountryEN": "Portugal",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "البرتغال",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 141,
    "iso3": "ROU",
    "iso": "RO",
    "CountryEN": "Romania",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "رومانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 163,
    "iso3": "ESP",
    "iso": "ES",
    "CountryEN": "Spain",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Europe",
    "countryAR": "إسبانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 164,
    "iso3": "LKA",
    "iso": "LK",
    "CountryEN": "Sri Lanka",
    "commentEN": null,
    "UNJoin": 1955,
    "Region": "Asia",
    "countryAR": "سريلانكا",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 85,
    "iso3": "JPN",
    "iso": "JP",
    "CountryEN": "Japan",
    "commentEN": null,
    "UNJoin": 1956,
    "Region": "Asia",
    "countryAR": "اليابان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 116,
    "iso3": "MAR",
    "iso": "MA",
    "CountryEN": "Morocco",
    "commentEN": null,
    "UNJoin": 1956,
    "Region": "Middle East",
    "countryAR": "المغرب",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 165,
    "iso3": "SDN",
    "iso": "SD",
    "CountryEN": "Sudan",
    "commentEN": null,
    "UNJoin": 1956,
    "Region": "Africa",
    "countryAR": "السودان",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 177,
    "iso3": "TUN",
    "iso": "TN",
    "CountryEN": "Tunisia",
    "commentEN": null,
    "UNJoin": 1956,
    "Region": "Middle East",
    "countryAR": "تونس",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 66,
    "iso3": "GHA",
    "iso": "GH",
    "CountryEN": "Ghana",
    "commentEN": "First African country to gain independence from the British.",
    "UNJoin": 1957,
    "Region": "Africa",
    "countryAR": "غانا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 103,
    "iso3": "MYS",
    "iso": "MY",
    "CountryEN": "Malaysia",
    "commentEN": null,
    "UNJoin": 1957,
    "Region": "Asia",
    "countryAR": "ماليزيا",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 70,
    "iso3": "GIN",
    "iso": "GN",
    "CountryEN": "Guinea",
    "commentEN": null,
    "UNJoin": 1958,
    "Region": "Africa",
    "countryAR": "غينيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 19,
    "iso3": "BEN",
    "iso": "BJ",
    "CountryEN": "Benin",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "بينين",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 27,
    "iso3": "BFA",
    "iso": "BF",
    "CountryEN": "Burkina Faso",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "بوركينا فاسو",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 30,
    "iso3": "CMR",
    "iso": "CM",
    "CountryEN": "Cameroon",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "الكاميرون",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 33,
    "iso3": "CAF",
    "iso": "CF",
    "CountryEN": "Central African Republic",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "أفريقيا الوسطى",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 34,
    "iso3": "TCD",
    "iso": "TD",
    "CountryEN": "Chad",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "تشاد",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 39,
    "iso3": "COG",
    "iso": "CG",
    "CountryEN": "Congo",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "الكونغو",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 41,
    "iso3": "CIV",
    "iso": "CI",
    "CountryEN": "Côte d’Ivoire",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "ساحل العاج",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 44,
    "iso3": "CYP",
    "iso": "CY",
    "CountryEN": "Cyprus",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Europe",
    "countryAR": "قبرص",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 50,
    "iso3": "COD",
    "iso": "CD",
    "CountryEN": "DRC",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "الكونغو الديمقراطية",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 62,
    "iso3": "GAB",
    "iso": "GA",
    "CountryEN": "Gabon",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "الغابون",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 101,
    "iso3": "MDG",
    "iso": "MG",
    "CountryEN": "Madagascar",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "مدغشقر",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 105,
    "iso3": "MLI",
    "iso": "ML",
    "CountryEN": "Mali",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "مالي",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 125,
    "iso3": "NER",
    "iso": "NE",
    "CountryEN": "Niger",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "النيجر",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 126,
    "iso3": "NGA",
    "iso": "NG",
    "CountryEN": "Nigeria",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "نيجيريا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 151,
    "iso3": "SEN",
    "iso": "SN",
    "CountryEN": "Senegal",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "السنغال",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 159,
    "iso3": "SOM",
    "iso": "SO",
    "CountryEN": "Somalia",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "الصومال",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 174,
    "iso3": "TGO",
    "iso": "TG",
    "CountryEN": "Togo",
    "commentEN": null,
    "UNJoin": 1960,
    "Region": "Africa",
    "countryAR": "توغو",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 108,
    "iso3": "MRT",
    "iso": "MR",
    "CountryEN": "Mauritania",
    "commentEN": null,
    "UNJoin": 1961,
    "Region": "Africa",
    "countryAR": "موريتانيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 114,
    "iso3": "MNG",
    "iso": "MN",
    "CountryEN": "Mongolia",
    "commentEN": null,
    "UNJoin": 1961,
    "Region": "Asia",
    "countryAR": "منغوليا",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 154,
    "iso3": "SLE",
    "iso": "SL",
    "CountryEN": "Sierra Leone",
    "commentEN": null,
    "UNJoin": 1961,
    "Region": "Africa",
    "countryAR": "سيراليون",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 172,
    "iso3": "TZA",
    "iso": "TZ",
    "CountryEN": "Tanzania",
    "commentEN": null,
    "UNJoin": 1961,
    "Region": "Africa",
    "countryAR": "تنزانيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 3,
    "iso3": "DZA",
    "iso": "DZ",
    "CountryEN": "Algeria",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Middle East",
    "countryAR": "الجزائر",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 28,
    "iso3": "BDI",
    "iso": "BI",
    "CountryEN": "Burundi",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Africa",
    "countryAR": "بوروندي",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 84,
    "iso3": "JAM",
    "iso": "JM",
    "CountryEN": "Jamaica",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Latin America",
    "countryAR": "جامايكا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 143,
    "iso3": "RWA",
    "iso": "RW",
    "CountryEN": "Rwanda",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Africa",
    "countryAR": "رواندا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 176,
    "iso3": "TTO",
    "iso": "TT",
    "CountryEN": "Trinidad and Tobago",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Latin America",
    "countryAR": "ترينداد وتوباغو",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 181,
    "iso3": "UGA",
    "iso": "UG",
    "CountryEN": "Uganda",
    "commentEN": null,
    "UNJoin": 1962,
    "Region": "Africa",
    "countryAR": "أوغندا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 88,
    "iso3": "KEN",
    "iso": "KE",
    "CountryEN": "Kenya",
    "commentEN": null,
    "UNJoin": 1963,
    "Region": "Africa",
    "countryAR": "كينيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 90,
    "iso3": "KWT",
    "iso": "KW",
    "CountryEN": "Kuwait",
    "commentEN": null,
    "UNJoin": 1963,
    "Region": "Middle East",
    "countryAR": "الكويت",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 102,
    "iso3": "MWI",
    "iso": "MW",
    "CountryEN": "Malawi",
    "commentEN": null,
    "UNJoin": 1964,
    "Region": "Africa",
    "countryAR": "ملاوي",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 106,
    "iso3": "MLT",
    "iso": "MT",
    "CountryEN": "Malta",
    "commentEN": null,
    "UNJoin": 1964,
    "Region": "Europe",
    "countryAR": "مالطا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 192,
    "iso3": "ZMB",
    "iso": "ZM",
    "CountryEN": "Zambia",
    "commentEN": null,
    "UNJoin": 1964,
    "Region": "Africa",
    "countryAR": "زامبيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 63,
    "iso3": "GMB",
    "iso": "GM",
    "CountryEN": "Gambia",
    "commentEN": null,
    "UNJoin": 1965,
    "Region": "Africa",
    "countryAR": "غامبيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 104,
    "iso3": "MDV",
    "iso": "MV",
    "CountryEN": "Maldives",
    "commentEN": null,
    "UNJoin": 1965,
    "Region": "Asia",
    "countryAR": "مالديف",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 155,
    "iso3": "SGP",
    "iso": "SG",
    "CountryEN": "Singapore",
    "commentEN": null,
    "UNJoin": 1965,
    "Region": "Asia",
    "countryAR": "سنغافورة",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 15,
    "iso3": "BRB",
    "iso": "BB",
    "CountryEN": "Barbados",
    "commentEN": null,
    "UNJoin": 1966,
    "Region": "Latin America",
    "countryAR": "بربادوس",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 23,
    "iso3": "BWA",
    "iso": "BW",
    "CountryEN": "Botswana",
    "commentEN": null,
    "UNJoin": 1966,
    "Region": "Africa",
    "countryAR": "بتسوانا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 72,
    "iso3": "GUY",
    "iso": "GY",
    "CountryEN": "Guyana",
    "commentEN": null,
    "UNJoin": 1966,
    "Region": "Latin America",
    "countryAR": "غيانا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 95,
    "iso3": "LSO",
    "iso": "LS",
    "CountryEN": "Lesotho",
    "commentEN": null,
    "UNJoin": 1966,
    "Region": "Africa",
    "countryAR": "ليسوتو",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 55,
    "iso3": "GNQ",
    "iso": "GQ",
    "CountryEN": "Equatorial Guinea",
    "commentEN": null,
    "UNJoin": 1968,
    "Region": "Africa",
    "countryAR": "غينيا الاستوائية",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 109,
    "iso3": "MUS",
    "iso": "MU",
    "CountryEN": "Mauritius",
    "commentEN": null,
    "UNJoin": 1968,
    "Region": "Africa",
    "countryAR": "موريشيوس",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 167,
    "iso3": "SWZ",
    "iso": "SZ",
    "CountryEN": "Swaziland",
    "commentEN": null,
    "UNJoin": 1968,
    "Region": "Africa",
    "countryAR": "سوازيلاند",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 59,
    "iso3": "FJI",
    "iso": "FJ",
    "CountryEN": "Fiji",
    "commentEN": null,
    "UNJoin": 1970,
    "Region": "Asia Pacific",
    "countryAR": "فيجي",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 13,
    "iso3": "BHR",
    "iso": "BH",
    "CountryEN": "Bahrain",
    "commentEN": null,
    "UNJoin": 1971,
    "Region": "Middle East",
    "countryAR": "البحرين",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 20,
    "iso3": "BTN",
    "iso": "BT",
    "CountryEN": "Bhutan",
    "commentEN": null,
    "UNJoin": 1971,
    "Region": "Asia",
    "countryAR": "بوتان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 130,
    "iso3": "OMN",
    "iso": "OM",
    "CountryEN": "Oman",
    "commentEN": null,
    "UNJoin": 1971,
    "Region": "Middle East",
    "countryAR": "عمان",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 140,
    "iso3": "QAT",
    "iso": "QA",
    "CountryEN": "Qatar",
    "commentEN": null,
    "UNJoin": 1971,
    "Region": "Middle East",
    "countryAR": "قطر",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 183,
    "iso3": "ARE",
    "iso": "AE",
    "CountryEN": "United Arab Emirates",
    "commentEN": null,
    "UNJoin": 1971,
    "Region": "Middle East",
    "countryAR": "الإمارات العربية المتحدة",
    "commentAR": null,
    "RegionAR": "الشرق الأوسط"
  },
  {
    "id": 12,
    "iso3": "BHS",
    "iso": "BS",
    "CountryEN": "Bahamas",
    "commentEN": null,
    "UNJoin": 1973,
    "Region": "Latin America",
    "countryAR": "بهاما",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 65,
    "iso3": "DEU",
    "iso": "DE",
    "CountryEN": "Germany",
    "commentEN": "East and West Germany admitted as full members.",
    "UNJoin": 1973,
    "Region": "Europe",
    "countryAR": "ألمانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 14,
    "iso3": "BGD",
    "iso": "BD",
    "CountryEN": "Bangladesh",
    "commentEN": null,
    "UNJoin": 1974,
    "Region": "Asia",
    "countryAR": "بنغلادش",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 68,
    "iso3": "GRD",
    "iso": "GD",
    "CountryEN": "Grenada",
    "commentEN": null,
    "UNJoin": 1974,
    "Region": "Latin America",
    "countryAR": "غرينادا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 71,
    "iso3": "GNB",
    "iso": "GW",
    "CountryEN": "Guinea-Bissau",
    "commentEN": null,
    "UNJoin": 1974,
    "Region": "Africa",
    "countryAR": "غينيا بيساو",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 32,
    "iso3": "CPV",
    "iso": "CV",
    "CountryEN": "Cape Verde",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Africa",
    "countryAR": "الرأس الأخضر",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 38,
    "iso3": "COM",
    "iso": "KM",
    "CountryEN": "Comoros",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Africa",
    "countryAR": "جزر القمر",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 117,
    "iso3": "MOZ",
    "iso": "MZ",
    "CountryEN": "Mozambique",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Africa",
    "countryAR": "موزمبيق",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 134,
    "iso3": "PNG",
    "iso": "PG",
    "CountryEN": "Papua New Guinea",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Asia Pacific",
    "countryAR": "بابوا غينيا الجديدة",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 149,
    "iso3": "STP",
    "iso": "ST",
    "CountryEN": "Sao Tome and Principe",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Africa",
    "countryAR": "ساوتومي و برنسيب",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 166,
    "iso3": "SUR",
    "iso": "SR",
    "CountryEN": "Suriname",
    "commentEN": null,
    "UNJoin": 1975,
    "Region": "Latin America",
    "countryAR": "سورينام",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 5,
    "iso3": "AGO",
    "iso": "AO",
    "CountryEN": "Angola",
    "commentEN": null,
    "UNJoin": 1976,
    "Region": "Africa",
    "countryAR": "أنغولا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 147,
    "iso3": "WSM",
    "iso": "WS",
    "CountryEN": "Samoa",
    "commentEN": null,
    "UNJoin": 1976,
    "Region": "Asia Pacific",
    "countryAR": "ساموا",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 153,
    "iso3": "SYC",
    "iso": "SC",
    "CountryEN": "Seychelles",
    "commentEN": null,
    "UNJoin": 1976,
    "Region": "Africa",
    "countryAR": "سيشل",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 47,
    "iso3": "DJI",
    "iso": "DJ",
    "CountryEN": "Djibouti",
    "commentEN": null,
    "UNJoin": 1977,
    "Region": "Africa",
    "countryAR": "جيبوتي",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 190,
    "iso3": "VNM",
    "iso": "VN",
    "CountryEN": "Vietnam",
    "commentEN": "Joined the UN following the end of a nearly 20-year long war.",
    "UNJoin": 1977,
    "Region": "Asia",
    "countryAR": "فيتنام",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 48,
    "iso3": "DMA",
    "iso": "DM",
    "CountryEN": "Dominica",
    "commentEN": null,
    "UNJoin": 1978,
    "Region": "Latin America",
    "countryAR": "دومينيكا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 158,
    "iso3": "SLB",
    "iso": "SB",
    "CountryEN": "Solomon Islands",
    "commentEN": null,
    "UNJoin": 1978,
    "Region": "Asia Pacific",
    "countryAR": "جزر سلومون",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 145,
    "iso3": "LCA",
    "iso": "LC",
    "CountryEN": "Saint Lucia",
    "commentEN": null,
    "UNJoin": 1979,
    "Region": "Latin America",
    "countryAR": "سنت لوسيا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 146,
    "iso3": "VCT",
    "iso": "VC",
    "CountryEN": "Saint Vincent and the Grenadines",
    "commentEN": null,
    "UNJoin": 1980,
    "Region": "Latin America",
    "countryAR": "سانت فنسنت وجزر غرينادين",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 193,
    "iso3": "ZWE",
    "iso": "ZW",
    "CountryEN": "Zimbabwe",
    "commentEN": null,
    "UNJoin": 1980,
    "Region": "Africa",
    "countryAR": "زيمبابوي",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 6,
    "iso3": "ATG",
    "iso": "AG",
    "CountryEN": "Antigua and Barbuda",
    "commentEN": null,
    "UNJoin": 1981,
    "Region": "Latin America",
    "countryAR": "أنتيغوا وبربودا",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 18,
    "iso3": "BLZ",
    "iso": "BZ",
    "CountryEN": "Belize",
    "commentEN": null,
    "UNJoin": 1981,
    "Region": "Latin America",
    "countryAR": "بليز",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 188,
    "iso3": "VUT",
    "iso": "VU",
    "CountryEN": "Vanuatu",
    "commentEN": null,
    "UNJoin": 1981,
    "Region": "Asia Pacific",
    "countryAR": "فانواتو",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 144,
    "iso3": "KNA",
    "iso": "KN",
    "CountryEN": "Saint Kitts and Nevis",
    "commentEN": null,
    "UNJoin": 1983,
    "Region": "Latin America",
    "countryAR": "سانت كيتس ونيفس",
    "commentAR": null,
    "RegionAR": "أميركا اللاتينية"
  },
  {
    "id": 25,
    "iso3": "BRN",
    "iso": "BN",
    "CountryEN": "Brunei Darussalam",
    "commentEN": null,
    "UNJoin": 1984,
    "Region": "Asia",
    "countryAR": "بروناي",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 98,
    "iso3": "LIE",
    "iso": "LI",
    "CountryEN": "Liechtenstein",
    "commentEN": null,
    "UNJoin": 1990,
    "Region": "Europe",
    "countryAR": "ليخنشتين",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 119,
    "iso3": "NAM",
    "iso": "NA",
    "CountryEN": "Namibia",
    "commentEN": null,
    "UNJoin": 1990,
    "Region": "Africa",
    "countryAR": "ناميبيا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 57,
    "iso3": "EST",
    "iso": "EE",
    "CountryEN": "Estonia",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Europe",
    "countryAR": "إستونيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 93,
    "iso3": "LVA",
    "iso": "LV",
    "CountryEN": "Latvia",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Europe",
    "countryAR": "لاتفيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 99,
    "iso3": "LTU",
    "iso": "LT",
    "CountryEN": "Lithuania",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Europe",
    "countryAR": "ليتوانيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 107,
    "iso3": "MHL",
    "iso": "MH",
    "CountryEN": "Marshall Islands",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Asia Pacific",
    "countryAR": "جزر مارشال",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 111,
    "iso3": "FSM",
    "iso": "FM",
    "CountryEN": "Micronesia",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Asia Pacific",
    "countryAR": "ميكرونيزيا",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 127,
    "iso3": "PRK",
    "iso": "KP",
    "CountryEN": "North Korea",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Asia",
    "countryAR": "كوريا الشمالية",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 161,
    "iso3": "KOR",
    "iso": "KR",
    "CountryEN": "South Korea",
    "commentEN": null,
    "UNJoin": 1991,
    "Region": "Asia",
    "countryAR": "كوريا الجنوبية",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 8,
    "iso3": "ARM",
    "iso": "AM",
    "CountryEN": "Armenia",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "أرمينيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 11,
    "iso3": "AZE",
    "iso": "AZ",
    "CountryEN": "Azerbaijan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "أذربيجان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 22,
    "iso3": "BIH",
    "iso": "BA",
    "CountryEN": "Bosnia and Herzegovina",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "بوسنة",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 42,
    "iso3": "HRV",
    "iso": "HR",
    "CountryEN": "Croatia",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "كرواتيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 64,
    "iso3": "GEO",
    "iso": "GE",
    "CountryEN": "Georgia",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "جورجيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 87,
    "iso3": "KAZ",
    "iso": "KZ",
    "CountryEN": "Kazakhstan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "كازاخستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 91,
    "iso3": "KGZ",
    "iso": "KG",
    "CountryEN": "Kyrgyzstan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "قرغيزستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 112,
    "iso3": "MDA",
    "iso": "MD",
    "CountryEN": "Moldova",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "مولدوفا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 148,
    "iso3": "SMR",
    "iso": "SM",
    "CountryEN": "San Marino",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "سان مارينو",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 157,
    "iso3": "SVN",
    "iso": "SI",
    "CountryEN": "Slovenia",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Europe",
    "countryAR": "سلوفينيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 171,
    "iso3": "TJK",
    "iso": "TJ",
    "CountryEN": "Tajikistan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "طاجيكستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 179,
    "iso3": "TKM",
    "iso": "TM",
    "CountryEN": "Turkmenistan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "تركمانستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 187,
    "iso3": "UZB",
    "iso": "UZ",
    "CountryEN": "Uzbekistan",
    "commentEN": null,
    "UNJoin": 1992,
    "Region": "Asia",
    "countryAR": "أوزبكستان",
    "commentAR": null,
    "RegionAR": "آسيا"
  },
  {
    "id": 4,
    "iso3": "AND",
    "iso": "AD",
    "CountryEN": "Andorra",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Europe",
    "countryAR": "أندورا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 45,
    "iso3": "CZE",
    "iso": "CZ",
    "CountryEN": "Czech Republic",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Europe",
    "countryAR": "تشيكيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 56,
    "iso3": "ERI",
    "iso": "ER",
    "CountryEN": "Eritrea",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Africa",
    "countryAR": "إريتريا",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  },
  {
    "id": 113,
    "iso3": "MCO",
    "iso": "MC",
    "CountryEN": "Monaco",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Europe",
    "countryAR": "موناكو",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 128,
    "iso3": "MKD",
    "iso": "MK",
    "CountryEN": "North Macedonia",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Europe",
    "countryAR": "مقدونيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 156,
    "iso3": "SVK",
    "iso": "SK",
    "CountryEN": "Slovakia",
    "commentEN": null,
    "UNJoin": 1993,
    "Region": "Europe",
    "countryAR": "سلوفاكيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 132,
    "iso3": "PLW",
    "iso": "PW",
    "CountryEN": "Palau",
    "commentEN": null,
    "UNJoin": 1994,
    "Region": "Asia Pacific",
    "countryAR": "بالاو",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 89,
    "iso3": "KIR",
    "iso": "KI",
    "CountryEN": "Kiribati",
    "commentEN": null,
    "UNJoin": 1999,
    "Region": "Asia Pacific",
    "countryAR": "كيريباس",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 120,
    "iso3": "NRU",
    "iso": "NR",
    "CountryEN": "Nauru",
    "commentEN": null,
    "UNJoin": 1999,
    "Region": "Asia Pacific",
    "countryAR": "ناورو",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 175,
    "iso3": "TON",
    "iso": "TO",
    "CountryEN": "Tonga",
    "commentEN": null,
    "UNJoin": 1999,
    "Region": "Asia Pacific",
    "countryAR": "تونغا",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 152,
    "iso3": "SRB",
    "iso": "RS",
    "CountryEN": "Serbia",
    "commentEN": null,
    "UNJoin": 2000,
    "Region": "Europe",
    "countryAR": "صربيا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 180,
    "iso3": "TUV",
    "iso": "TV",
    "CountryEN": "Tuvalu",
    "commentEN": null,
    "UNJoin": 2000,
    "Region": "Asia Pacific",
    "countryAR": "توفالو",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 51,
    "iso3": "TLS",
    "iso": "TL",
    "CountryEN": "East Timor",
    "commentEN": null,
    "UNJoin": 2002,
    "Region": "Asia Pacific",
    "countryAR": "تيمور الشرقية",
    "commentAR": null,
    "RegionAR": "آسيا والمحيط الهادئ"
  },
  {
    "id": 169,
    "iso3": "CHE",
    "iso": "CH",
    "CountryEN": "Switzerland",
    "commentEN": null,
    "UNJoin": 2002,
    "Region": "Europe",
    "countryAR": "سويسرا",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 115,
    "iso3": "MNE",
    "iso": "ME",
    "CountryEN": "Montenegro",
    "commentEN": null,
    "UNJoin": 2006,
    "Region": "Europe",
    "countryAR": "الجبل الأسود",
    "commentAR": null,
    "RegionAR": "أوروبا"
  },
  {
    "id": 162,
    "iso3": "SSD",
    "iso": "SS",
    "CountryEN": "South Sudan",
    "commentEN": "Newest country to join the UN.",
    "UNJoin": 2011,
    "Region": "Africa",
    "countryAR": "جنوب السودان",
    "commentAR": null,
    "RegionAR": "أفريقيا"
  }
]
export default JoinUNdata